import axios from 'helpers/axios';

/**
 * Список румов
 */
export const getRooms = async () => {
    const { data } = await axios.get('/api/adminapi/grid/networks/');

    return data;
};